<template>
	<div class="fast-service">
		<common-layout>
			<div slot="header">
				<h3>快速服务信息收集</h3>
			</div>
			<div slot="container">
				<div class="fast-service.header">
					<div class="fast-service.date">
						<el-date-picker v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						 format="yyyy-MM-dd" value-format="yyyy-MM-dd">
						</el-date-picker>
					</div>
					<div class="fast-service.search">
						<el-input placeholder="请输入申请人" v-model="searchVal" class="input-with-select">
							<el-button slot="append" icon="el-icon-search" @click="getAllLists"></el-button>
						</el-input>
					</div>
					<div class="fast-service.select">
						<label>状态: </label>
						<el-select v-model="selectStatusVal" placeholder="全部状态">
							<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
					<div>
						<label>类型: </label>
						<el-select v-model="selectTypeVal" placeholder="全部类型">
							<el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="fast-service.table">
					<el-table :data="userCollectionData" border style="width: 100%" :header-cell-style="headerStyle">
						<el-table-column label="序号" type="index" width="180" align="center">
							<template slot-scope="scope"><span>{{scope.$index+(pageMNo - 1) * 15 + 1}} </span></template>
						</el-table-column>
						<el-table-column label="信息类型" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.type == 1">科技成果</span>
								<span v-else-if="scope.row.type == 2">知识产权</span>
								<span v-else-if="scope.row.type == 3">科技金融</span>
								<span v-else-if="scope.row.type == 4">创新创业</span>
								<span v-else-if="scope.row.type == 5">共享服务</span>
								<span v-else>其他</span>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="申请人" align="center">
						</el-table-column>
						<el-table-column prop="phone" label="联系电话" align="center">
						</el-table-column>
						<el-table-column prop="dateTime" label="申请时间" align="center">
						</el-table-column>
						<el-table-column label="状态" align="center">
							<template slot-scope="scope">
								{{scope.row.status == 1 ? '未沟通' :'已沟通'}}
							</template>
						</el-table-column>
						<el-table-column prop="remarks" label="备注" align="center">
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-button size="mini" @click="showModal(scope.row)">编辑</el-button>
								<el-button size="mini" type="danger" @click="deteInfo(scope.row.id)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="fast-service.page">
					<el-pagination background layout="prev, pager, next" :hide-on-single-page="true" @size-change="handleMChange"
					 @current-change="handleMCurrentChange" :current-page.sync="pageMNo" :page-size="15" :total="totalMCount">
					</el-pagination>
				</div>
			</div>
		</common-layout>
		<el-dialog title="用户详情" :visible.sync="userCollectionVisible" :modal-append-to-body="false">
			<el-form :model="userCollectionform" ref="userCollectionform" :rules="userCollectionformRules">
				<el-form-item label="信息类型" :label-width="formLabelWidth">
					<el-select v-model="userCollectionform.type" placeholder="请选择类型" :disabled="true">
						<el-option :label="item.label" :value="item.value" v-for="item in typeOptions" :key="item.value"></el-option>
						<!-- <el-option label="商标名称征集" :value="2"></el-option>
						<el-option label="版权注册" :value="3"></el-option>
						<el-option label="商标快捷登记" :value="4"></el-option>
						<el-option label="快速服务通道" :value="5"></el-option>
						<el-option label="商品/服务咨询" :value="6"></el-option> -->
					</el-select>
				</el-form-item>
				<el-form-item label="申请人" :label-width="formLabelWidth">
					<el-input v-model="userCollectionform.name" autocomplete="off" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" :label-width="formLabelWidth">
					<el-input v-model="userCollectionform.phone" autocomplete="off" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="信息详情" :label-width="formLabelWidth">
					<el-input v-model="userCollectionform.content" autocomplete="off" :disabled="true" type="textarea" :rows="3"></el-input>
				</el-form-item>
				<el-form-item label="状态" :label-width="formLabelWidth" prop="status">
					<el-select v-model="userCollectionform.status" placeholder="请选择状态">
						<el-option label="已沟通" :value="2"></el-option>
						<el-option label="未沟通" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注" :label-width="formLabelWidth">
					<el-input v-model="userCollectionform.remarks" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="userCollectionVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmEditUser(userCollectionform.id)">确 定</el-button>
			</div>
		</el-dialog>
	</div>

</template>

<script>
	import CommonLayout from '../../components/common-layout.vue'
	import '../../libs/formatDate';
	export default {
		components: {
			CommonLayout
		},
		data() {
			return {
				totalMCount: 0,
				pageMNo: 1,
				userCollectionVisible: false,
				formLabelWidth: '120px',
				headerStyle: {
					color: '#583e7e',
					background: '#E5F3FE'
				},
				statusOptions: [{
					value: null,
					label: '全部状态'
				}, {
					value: 1,
					label: '未沟通'
				}, {
					value: 2,
					label: '已沟通'
				}],
				typeOptions: [{
						value: null,
						label: '全部信息类型'
					},
					{
						value: 1,
						label: '科技成果'
					},
					{
						value: 2,
						label: '知识产权'
					},
					{
						value: 3,
						label: '科技金融'
					},
					{
						value: 4,
						label: '创新创业'
					},
					{
						value: 5,
						label: '共享服务'
					}

				],
				selectTypeVal: '',
				selectStatusVal: '',
				dateVal: '',
				searchVal: '',
				userCollectionData: [],
				userCollectionform: {
					type: '',
					name: '',
					phone: '',
					remarks: '',
					status: '',
					content: ''
				},
				userCollectionformRules: {
					status: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}]
				}
			}

		},
		methods: {
			confirmEditUser(id) {
				this.$refs['userCollectionform'].validate((valid) => {
					if (valid) {
            this.userCollectionform.id = id
						this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/channel/update`, this.userCollectionform).then(res => {
							console.log(res)
							if (res.code == 0) {
								this.$message.success('编辑成功')
								this.userCollectionVisible = false
								this.initData()
							}
						}).catch(error => {
							this.$message.error(error)
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			showModal(row) {
				this.userCollectionVisible = true;
				this.resetForm();
				this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/channel/get?id=${row.id}`).then(res => {
					this.userCollectionform = Object.assign({}, res.data);
				}).catch(error => {
					this.$message.error(error)
				})
			},
			initData() {
				/*this.http.get(`Channel?notype=6&page=${this.pageMNo}`)
					.then(result => {
						if (this.userCollectionData != null) {
							this.userCollectionData = result.data.data
							this.totalMCount = result.data.total


						}
					}).catch(error => {
						this.$message.error(error)
					})*/
         this.getPageMData('all');
			},
			getPageMData(params) {
        if( params){
          this.pageMNo = 1
        }
        let param = {
          notype:6,
          page: this.pageMNo,
          startTime: this.dateVal ? this.dateVal[0] : '',
          endTime: this.dateVal ? this.dateVal[1] : '',
          name: this.searchVal,
          type: this.selectTypeVal == null ? '' : this.selectTypeVal,
          status: this.selectStatusVal == null ? '' : this.selectStatusVal
        }
				/*let url;
				if (params) {
					url =
						`Channel?notype=6&start_time=${this.dateVal ? this.dateVal[0]:''}&end_time=${this.dateVal ? this.dateVal[1]:''}&name=${this.searchVal}&type=${this.selectTypeVal == null ? '' : this.selectTypeVal}&status=${this.selectStatusVal == null ? '' : this.selectStatusVal}`
				} else {
					url =
						`Channel?notype=6&page=${this.pageMNo}&start_time=${this.dateVal ? this.dateVal[0]:''}&end_time=${this.dateVal ? this.dateVal[1]:''}&name=${this.searchVal}&type=${this.selectTypeVal == null ? '' : this.selectTypeVal}&status=${this.selectStatusVal == null ? '' : this.selectStatusVal}`
				}*/
        this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/channel/page`, param).then(res => {
					if (res.code == 0) {
						this.userCollectionData = res.data.data
						this.totalMCount = res.data.total
						this.pageMNo = res.data.current_page

					}
				})

			},
			deteInfo(id) {
				this.$confirm("确定删除吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true
					}).then(() => {
					this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/channel/delete?id=${id}`, "", "delete")
					.then(result => {
								if (result.code === 0) {
									this.$message.success('删除成功')
									this.initData()
								}
							})
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			},
			handleMChange(val) {
				this.$nextTick(() => {
					this.getPageMData()
				})
			},
			handleMCurrentChange(val) {
				this.getPageMData()
			},
			getAllLists() {
				this.getPageMData('all')
			},
			resetForm() {
				this.userCollectionform.status = ''
				this.userCollectionform.remarks = ''
			}
		},
		mounted() {
			this.initData()
		},
		watch: {
			dateVal: {
				handler(newVal) {
					if (newVal || newVal == null) {
						this.getPageMData('all')
					}

				},
				deep: true,
				immediate: true
			},
			selectTypeVal: {
				handler(newVal) {
					if (newVal || newVal == null) {
						this.getPageMData('all')
					}

				},
				deep: true,
				immediate: true
			},
			selectStatusVal: {
				handler(newVal) {
					if (newVal || newVal == null) {
						this.getPageMData('all')
					}

				},
				deep: true,
				immediate: true
			}
		}
	};
</script>
<style lang="scss">
	@include component(fast-service) {
		height: 100%;
		@include part(header) {
			width: 100%;
			display: flex;
		}
			
		@include part(select) {
			margin: 0 30px;
			font-size: 14px;
		}
		
		@include part(search) {
			margin-left: 30px;
			
			@include component(el-button) {
			
			}
		}
		@include component(el-form-item__content) {
			// width: 500px;
			// float: left;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
		
			
		@include part(table) {
			margin-top: 20px;
			width: 100%;
		}
		@include part(page) {
			margin-top: 10px;
			margin-bottom: 30px;
		}
		@include component(el-range-separator){
			width: 10%;
		}
	}
	
</style>
